export default "__VITE_ASSET__mnkrZ5HV__"